

export const InputText = ({question, default_value, setDefault, show_secondary_label, override_label})  => {

    return (
        <div className="my-2">
            <label className="block my-1 text-sm font-medium text-gray-900">
                {override_label ? override_label : question.label}
                {question.required? '*': null}
            </label>
            <input name={question.id} type={question.type} id={question.id}
            defaultValue={default_value}
            onChange={event =>  setDefault(event.target.value) }
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
            placeholder={
                show_secondary_label && question.info_secondary?.length > 0
                ? question.info_secondary
                : question.info}
            required={question.required}/>
        </div>
    );
}